import { render, staticRenderFns } from "./shifts.vue?vue&type=template&id=2e573cd3&scoped=true&"
import script from "./shifts.vue?vue&type=script&lang=js&"
export * from "./shifts.vue?vue&type=script&lang=js&"
import style0 from "./shifts.vue?vue&type=style&index=0&id=2e573cd3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e573cd3",
  null
  
)

export default component.exports